var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
export var SectionSubHeading = styled.h3(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: block;\n  color: ", ";\n  font-size: 1.6rem;\n  font-weight: bold;\n  letter-spacing: 1.08px;\n  line-height: 1em;\n  margin: 0 0 20px 0;\n  text-transform: uppercase;\n"], ["\n  display: block;\n  color: ", ";\n  font-size: 1.6rem;\n  font-weight: bold;\n  letter-spacing: 1.08px;\n  line-height: 1em;\n  margin: 0 0 20px 0;\n  text-transform: uppercase;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.black;
});
var templateObject_1;
//# sourceMappingURL=SectionSubHeading.js.map